export default {
    currScroll: 0,
    prevScroll: 0,
    direction: 'down',
    MINIMUM_SCROLL: 150,
    init() {
        let nav = document.querySelector('#header');
        if(nav) {
            this.currScroll = document.documentElement.scrollTop;
            this.prevScroll = this.currScroll

            window.addEventListener('scroll', e => {
                let scrollY;
                if(navigator.userAgent.indexOf('MSIE')!==-1
                    || navigator.appVersion.indexOf('Trident/') > -1){
                    scrollY = window.pageYOffset;
                } else {
                    scrollY = window.scrollY;
                }
                this.currScroll = scrollY;
                let direction = this.scrollDirection();
                // console.log(direction);
                // console.log("Prev scroll: " + this.prevScroll + " curr scroll: " + this.currScroll);
                //if direction has changed
                if(this.currScroll >= this.MINIMUM_SCROLL) {
                    if (!nav.classList.contains('fixed')) {
                        nav.classList.add('fixed');
                        nav.classList.remove('removed');
                    }
                    // if (direction !== this.direction) {
                    //     window.requestAnimationFrame(() => {
                    //         if (direction === 'up') {

                    //         }
                    //         // } else {
                    //         //     //only hide the menu if it was actually visible.
                    //         //     if(nav.classList.contains('fixed')) {
                    //         //         nav.classList.remove('fixed');
                    //         //         nav.classList.add('removed');
                    //         //     }
                    //         // }

                    //         // console.log("Nav.js: Old direction " + this.direction + " new direction: " + direction)
                    //         this.direction = direction;
                    //     })
                    // }
                } else {
                    nav.classList.remove('removed');
                    nav.classList.remove('fixed');
                }

                this.prevScroll = this.currScroll;
            })
        }
    },
    scrollDirection() {
        return (this.currScroll < this.prevScroll) ? 'up' : 'down';
    }
}